{
  "nl": {
    "ai": {
      "settings": {
        "title": "AI-instellingen",
        "description": "Configuratie voor AI-functies binnen jullie werkomgeving.",
        "budget": {
          "title": "Maandelijks budget",
          "description": "Maximale kost per maand voor AI-gebruik (test-fase). Wordt herberekend op basis van token-verbruik van alle gesprekken deze maand.",
          "budget_label": "Budget",
          "usage_label": "Verbruikt deze maand",
          "save": "Opslaan"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "Alle projecten",
        "empty_state": {
          "title": "Hoe kan ik u helpen?",
          "subtitle": "Stel me alles over uw klanten"
        },
        "suggestions": {
          "open_decisions": "Welke beslissingen staan nog open?",
          "unassigned_units": "Welke units hebben nog geen klant?",
          "help_notifications": "Hoe stel ik notificaties in?",
          "help_project_settings": "Waar vind ik project-instellingen?"
        },
        "input": {
          "placeholder": "Vraag over uw klanten...",
          "hint": "Enter om te verzenden · Shift+Enter voor nieuwe regel",
          "disclaimer": "Resultaten kunnen onnauwkeurig zijn. Controleer belangrijke informatie altijd."
        },
        "errors": {
          "generic": "Er is iets misgegaan. Probeer het opnieuw.",
          "budget_reached": "Het maandelijkse AI-budget voor deze werkomgeving is bereikt. Neem contact op met een beheerder om de limiet te verhogen."
        },
        "cap": {
          "message": "U heeft de gespreksbeperking bereikt.",
          "action": "Start een nieuw gesprek"
        },
        "history": {
          "title": "Vorige gesprekken",
          "empty": "Nog geen vorige gesprekken"
        },
        "support_cta": {
          "prompt": "Antwoord niet wat u zocht?",
          "action": "Neem contact op met support"
        }
      }
    }
  }
}
